module.exports = __webpack_public_path__ + "images/db-logos/hive.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/db-logos/hive.png
// module id = 311
// module chunks = 1